const LISTENERS = {};
const QUEUE = {};

export function registerListener(taskID, listener) {
  LISTENERS[taskID] = listener;
  if (QUEUE.hasOwnProperty(taskID)) {
    const {event, meta} = QUEUE[taskID];
    listener(event, meta);
    delete QUEUE[taskID];
  }
}

export function unregisterListener(taskID) {
  delete LISTENERS[taskID];
}

export function onEvent(event, meta) {
  const {task_id: taskID} = meta;
  if (LISTENERS.hasOwnProperty(taskID)) {
    LISTENERS[taskID](event, meta);
  } else {
    QUEUE[taskID] = {event, meta};
  }
}
